export const URL_MAX_LENGTH = 500;

const ALLOWED_PROTOCOLS = ['http:', 'https:'];

/**
 * Verifica se o valor é uma URL absoluta com protocolo http ou https.
 * Mesma regra aplicada no fidegg-admin-api (app/Helpers/UrlValidator.js).
 */
export function isValidHttpUrl(value: string): boolean {
  if (!value || value.length > URL_MAX_LENGTH) {
    return false;
  }

  try {
    const url = new URL(value);
    return ALLOWED_PROTOCOLS.includes(url.protocol);
  } catch (err) {
    return false;
  }
}
